import { useMyDataQuery, usePlansQuery } from '@/generated/graphql';
import { resolveMaxExpiryDays } from '@/lib/publishing/isPostableClip';

export function usePostableClipExpiry(enabled: boolean): number | null {
  const { data: myData } = useMyDataQuery({ skip: !enabled });
  const subscription = myData?.myData?.subscription as {
    max_expiry_days?: number | null;
    plan?: {
      max_expiry_days?: number | null;
      name?: string | null;
      slug?: string | null;
    } | null;
  } | null | undefined;
  const known = resolveMaxExpiryDays({ subscription });
  const { data: plansData } = usePlansQuery({ skip: !enabled || known != null });
  return resolveMaxExpiryDays({ subscription, plans: plansData?.plans });
}
